<template>
  <div class="text-and-counter">
    <div class="wrap">
      <div class="left-side">
        <div
          v-dompurify-html="section.infoTitle"
          class="title"
        />
        <div
          v-if="!isMobile"
          class="description"
        >
          <div v-dompurify-html="section.infoBody" />
          <a
            v-if="section.readMoreLink !== ''"
            :href="section.readMoreLink"
            :target="section.readMoreLinkTarget"
          >
            {{ section.readMoreLinkText }}
          </a>
        </div>
      </div>

      <count-down-block
        v-if="isTimeSet()"
        :deadline="constructTime()"
        :title="section.counterTitle"
      />

      <div
        v-if="isMobile"
        class="description"
      >
        <div v-dompurify-html="section.infoBody" />
        <a
          v-if="section.readMoreLink !== ''"
          :href="section.readMoreLink"
          :target="section.readMoreLinkTarget"
        >
          {{ section.readMoreLinkText }}
        </a>
      </div>
    </div>
  </div>
</template>
<script>
  import CountDownBlock from 'containers/Pages/LandingPage/CountDownBlock'
  import moment from 'moment'
  import { mapGetters } from 'vuex'

  export default {
    components: {
      CountDownBlock
    },
    props: {
      section: {
        type: Object,
        required: true,
        default: () => ({
          infoTitle: '',
          infoBody: '',
          readMoreLink: '',
          readMoreLinkText: '',
          readMoreLinkTarget: '',
          time: '',
          date: '',
          counterTitle: ''
        })
      }
    },
    computed: {
      ...mapGetters('device', [
        'isMobile'
      ])
    },
    methods: {
      isTimeSet () {
        return this.section.time !== '' && this.section.date !== ''
      },
      constructTime () {
        if (this.section.date !== '') {
          const date = moment(this.section.date)
          if (this.section.time) {
            date.set({
              hours: this.section.time.split(':')[0],
              minutes: this.section.time.split(':')[1]
            })
          }
          return date
        }

        return {}
      }
    }
  }
</script>
<style lang="scss" scoped rel="stylesheet/scss">
  @import "~assets/styles/common.scss";

  .text-and-counter {
    border-top: 1px solid $grey-white-3;
    padding-bottom: 40px;

    @include bp-mf-desktop() {
      padding-bottom: 70px;
    }

    .wrap {
      line-height: 1.15;
      padding: 0 23px;
      @include clearfix();
      @include bp-mf-tablet {
        padding: 0 26px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }

      @include bp-mf-desktop() {
        max-width: $desktop-width;
        padding: 0;
      }

      .left-side {

        @include bp-mf-tablet() {
          width: 50%;
        }

        @include bp-mf-desktop() {
          padding: 0;
          max-width: $desktop-width;
        }

        .title {
          padding: 34px 0 19px 0;
          font-size: em(23);
          font-weight: 700;
          line-height: 1.18;

          @include bp-mf-tablet() {
            padding: 46px 70px 0 0;
          }

          @include bp-mf-desktop() {
            font-size: em(32);
            padding: 60px 70px 0 0;
          }
        }
      }
    }

    .description {
      line-height: 1.65;
      font-size: em(12);

      a {
        display: block;
        text-decoration: none;
        color: #b7c50b;

        @include bp-mf-desktop() {
          margin-top: 40px;
        }
      }

      @include bp-mf-tablet() {
        line-height: 1.5;
        padding: 0 70px 0 0;
      }

      @include bp-mf-desktop() {
        font-size: em(14);
      }
    }

    .countdown-block {
      padding: 0;
      height: auto;
      background: none;
      text-align: center;

      @include bp-mf-tablet() {
        text-align: left;
        width: 50%;
        margin: 0;
        padding-top: 46px;
        padding-left: 52px;
        box-shadow: 0 0, 0 0;
      }

      @include bp-mf-desktop() {
        padding-top: 70px;
        padding-left: 13px;
      }

      /deep/ {

        h4 {
          text-align: center;
          font-size: em(12);
          padding-bottom: 10px;
          padding-left: 0;

          @include bp-mf-tablet() {
            color: #9a9a9a;
            font-size: em(13);
            font-weight: 700;
          }
        }

        .countdown-title {
          @include bp-mf-tablet() {
            padding-bottom: 29px;
            text-align: left;
          }

          @include bp-mf-desktop() {
            font-size: em(18);
            padding-bottom: 40px;
          }
        }

        .countdown-item {

          @include bp-mf-desktop() {
            width: 76px;
            height: 74px;
            margin-right: 14px;
          }

          .countdown-square {
            background: #cdde00;

            @include bp-mf-tablet() {
              text-align: center;
            }

            @include bp-mf-desktop() {
              width: 76px;
              height: 74px;
              line-height: 78px;
              font-size: em(40);
              font-weight: 400;
            }
          }

          .countdown-description {
            color: $grey-default;
            font-size: em(12);
            text-align: center;
            font-weight: 700;

            @include bp-mf-desktop() {
              font-size: em(16);
            }
          }
        }
      }
    }
  }
</style>
